import { ICalendarIntegrationSettings } from "@performyard/models";
import type {
	DisconnectCalendarIntegrationResponse,
	GetCompanyCalendarIntegrationSettingsResponse,
	GetUserCalendarIntegrationStatusResponse,
	GetUserCalendarsResponse,
	InitiateCalendarIntegrationOAuthFlowResponse,
	SaveSelectedCalendarRequest,
	SaveSelectedCalendarResponse,
	UpdateCompanyCalendarIntegrationSettingsResponse,
} from "@performyard/service-contracts";

import request from "./internal-base-request";

export const getCompanyCalendarIntegrationSettings =
	async (): Promise<GetCompanyCalendarIntegrationSettingsResponse> => {
		const [response] = await request<GetCompanyCalendarIntegrationSettingsResponse>(
			"/v1/calendar-integrations/settings"
		);
		return response;
	};

export const updateCompanyCalendarIntegrationSettings = async (
	data: ICalendarIntegrationSettings
): Promise<UpdateCompanyCalendarIntegrationSettingsResponse> => {
	const [response] = await request<UpdateCompanyCalendarIntegrationSettingsResponse>(
		"/v1/calendar-integrations/settings",
		{
			method: "PATCH",
			body: JSON.stringify(data),
		}
	);
	return response;
};

export const getCalendarIntegrationOAuthUrl = async ({
	provider,
}: {
	provider: "google" | "outlook";
}): Promise<InitiateCalendarIntegrationOAuthFlowResponse> => {
	const [data] = await request<InitiateCalendarIntegrationOAuthFlowResponse>(
		`/v1/calendar-integrations/oauth/initiate/${provider}`
	);
	return data;
};

export const getUserCalendarIntegrationStatus = async (): Promise<GetUserCalendarIntegrationStatusResponse> => {
	const [response] = await request<GetUserCalendarIntegrationStatusResponse>("/v1/calendar-integrations/status");
	return response;
};

/**
 * Unified method to get user calendars from any provider
 */
export const getUserCalendars = async ({
	provider,
}: {
	provider: "google" | "outlook";
}): Promise<GetUserCalendarsResponse> => {
	const [response] = await request<GetUserCalendarsResponse>(`/v1/calendar-integrations/${provider}/calendars`);
	return response;
};

export const saveSelectedCalendar = async (
	data: SaveSelectedCalendarRequest
): Promise<SaveSelectedCalendarResponse> => {
	const [response] = await request<SaveSelectedCalendarResponse>("/v1/calendar-integrations/calendar/select", {
		method: "POST",
		body: JSON.stringify(data),
	});
	return response;
};

export const disconnectCalendarIntegration = async (): Promise<DisconnectCalendarIntegrationResponse> => {
	const [response] = await request<DisconnectCalendarIntegrationResponse>("/v1/calendar-integrations/disconnect", {
		method: "DELETE",
	});
	return response;
};
